
$(document).ready(function() {
 var slider = $(".slider_type01").slick({
	//autoplay: true, //自動再生
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 1,
    //prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
    //nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',
responsive: [
 {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
	  	dots: false,
      }}]
 });
//↓ここがポイント!タブの切替ボタンをクリックしたらsetPositionが動く
 $('.collection-tabs li').click(function(){//クラス名を指定しました
 slider.slick('setPosition');
 });
 });

 $(document).ready(function() {
    $(".slider_type02").slick({
        //autoplay: true, //自動再生
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        //prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
        //nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "25%",
                    dots: false,
                }
            }
        ]
    });
});

 $(document).ready(function() {
    $(".slider_type03").slick({
        //autoplay: true, //自動再生
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        //prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
        //nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "25%",
                    dots: false,
                }
            }
        ]
    });
});


/* 開閉パネル
-------------------------------------------------------- */
$(function() {
	$('.toggle_box__more').on('click', function() {
		if( $(this).children().is('.open') ) {
			$(this).html('<p class="close">閉じる</p>').addClass('toggle_box__close');
			$(this).parent().removeClass('slide-up').addClass('slide-down');
		} else {
			$(this).html('<p class="open">もっと見る</p>').removeClass('toggle_box__close');
			$(this).parent().removeClass('slide-down').addClass('slide-up');
		}
	});
});


/* 画像効果
-------------------------------------------------------- */
$(function(){
    var setElm = $('.in-scroll img'),
    delayHeight = 100;

    setElm.css({display:'block',opacity:'0',position:'relative'});
    $('html,body').animate({scrollTop:0},1);

	$(window).on('scroll', function (i){
        setElm.each(function(){
            var setThis = $(this),
            elmTop = setThis.offset().top,
            elmHeight = setThis.height(),
            scrTop = $(window).scrollTop(),
            winHeight = $(window).height();

            if (scrTop > elmTop - winHeight + delayHeight && scrTop < elmTop + elmHeight){
                setThis.stop().animate({top: '0',opacity:'1'},500);
            } else if (scrTop < elmTop - winHeight + delayHeight && scrTop < elmTop + delayHeight){
                setThis.stop().animate({top:'30px',opacity:'0'},500);
            }
        });
    });
});


/* タブ切り替え
-------------------------------------------------- */
$(function() {
	$('.tab li').click(function() {
		var index = $('.tab li').index(this);
		$('.tabcontent .tabbox').css('display','none');
		$('.tabcontent .tabbox').eq(index).css('display','block');
		$('.tab li').removeClass('select');
		$(this).addClass('select')
	});
});


/* 即日発送モーダル
-------------------------------------------------- */
$(function () {
    $('#js-same-day-delivery-modal-open').on('click', function(){
        var returnToInput = document.querySelector('input[name="return_to"]');
        if (returnToInput) {
        returnToInput.value = location.href;
        }
        $('.js-same-day-delivery-modal').fadeIn();
    });
    $('.js-same-day-delivery-modal-close').on('click', function(){
        $('.js-same-day-delivery-modal').fadeOut();
        return false;
    });
});



/* All in gift バグ対応
-------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function() {
        document.querySelectorAll('li > small.text-muted').forEach(function(small) {
            var propertyName = small.textContent.trim();
            if (propertyName.includes("_gift_options_variant_id") || propertyName.includes("_cart_gift_variant_id")) {
                small.parentElement.style.display = "none";
            }
        });
    }, 200);
});


/* collection-template--with-login ログインモーダル
-------------------------------------------------- */
$(function () {
    // ページがロードされたときにモーダルを表示する
    $('.js-login-modal').fadeIn();

    // モーダルを閉じる処理
    $('.js-login-modal-close').on('click', function() {
        $('.js-login-modal').fadeOut();
    });
});
